import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';
import Text from '@/v1/components/atoms/Text';
import Dialog from '@/v1/components/layouts/Dialog';
import Button from '@/v1/components/atoms/Button';
import LowPower from '@/v1/components/atoms/Icon/LowPower';
import Warning from '@/v1/components/atoms/Icon/Warning';
import { ApplicationContext } from '@/v1/state/providers';
import { IsIOS } from '../../utils/DeviceUtils/DeviceUtils';
import './LowPowerWarning.scss';

/**
 * Video playback and body classname
 * handled in VideoController
 */

export default () => {
    const shouldRender = IsIOS();
    const [lowPowerWarningSeen, setLowPowerWarningSeen] = useState(false);
    const [data] = useContext(ApplicationContext);
    const { lowPowerFullScreenWarning, lowPowerContinueCTA, lowPowerTapWarning } = data?.device?.ios;

    const onBodyClick = () => {
        setTimeout(() => setLowPowerWarningSeen(true), 600);
    };

    useEffect(() => {
        if (shouldRender) {
            document.addEventListener('click', onBodyClick);
        }

        return () => {
            document.removeEventListener('click', onBodyClick);
        };
    }, []);

    const overlayContent = () => (
        <>
            <div className="LowPowerWarning__icon">
                <LowPower />
            </div>
            <div className="LowPowerWarning__heading">
                <Text className="p transform-normal">{lowPowerFullScreenWarning}</Text>
                <Button variant="secondary-light">{lowPowerContinueCTA}</Button>
            </div>
        </>
    );

    const dialogContent = () => <Dialog bodyTextIcon={<Warning />} bodyText={lowPowerTapWarning} />;

    const lowPowerClasses = classNames({
        LowPowerWarning: true,
        'LowPowerWarning--overlay': !lowPowerWarningSeen,
        'LowPowerWarning--warning': lowPowerWarningSeen,
    });

    if (shouldRender) {
        return <div className={lowPowerClasses}>{!lowPowerWarningSeen ? overlayContent() : dialogContent()}</div>;
    }

    return null;
};
